// @ts-nocheck
import React, { useState, useEffect, useContext, useRef } from 'react';
import ManageBundle from '@/components/bundle/manage';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';
import BillingService from '@/services/billing-service';
import Helper from '@/utils/helper';
import SubscriptionContext from '@/utils/subscription-context';
import ManageBundleComponent from '@/PageComponents/Bundle/ManageBundleComponent';
import Breadcrumbs from '@/components/breadcrumbs';
import { useRouter } from 'next/router';
import {Box, Card, Flex} from "@mantine/core";
import {useElementSize} from "@mantine/hooks";
import { createFileRoute } from '@tanstack/react-router'



function CreateBundle() {
  const subscriptionContext = useContext(SubscriptionContext);
  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const router = useRouter();

  const getAccessStatus = async () => {
    const [subscriptionInfo, message] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(router.replace, "/");
    }
  }, [accessStatus]);

  const {height: toolbarHeight, ref: toolbarRef} = useElementSize()

  return (
      <div>
        <Box bg={'white'} ref={toolbarRef} pb={'sm'}>
          <Flex justify={'apart'} w={'100%'} mt={'15px'} gap={'sm'} px={10}>
            <Flex align={'center'} >
              <Breadcrumbs currPage={{ text: 'Create Bundle', link: '/bundle/create', type: 'create' }} />
            </Flex>
          </Flex>
        </Box>
        <Box
            py={{base: 5, xs: 8, sm: 'md'}}
            px={{base: 5, xs: 8}}
            mih={`calc(100vh - ${(toolbarHeight ? (toolbarHeight + 68) : 166)}px)`}
        >
          <Card
              p={'md'}
              px={{base: 1, xs: 5, sm: 'sm'}}
              radius={'md'}
          >
            <Box maw={1000}>
              <ManageBundleComponent />
            </Box>
          </Card>
        </Box>
      </div>
  );
}

export default CreateBundle;

export const Route = createFileRoute('/_authenticated/bundle/create')({ component: CreateBundle })
